import styled from 'styled-components';
import spacing from '../../../theme/shared/spacing';
import Link from '../../Atoms/Link/Link';
var FooterWrapper = styled.footer.attrs(function () {
  return {
    role: 'banner'
  };
}).withConfig({
  displayName: "Footerstyle__FooterWrapper",
  componentId: "sc-167xaf5-0"
})(["text-align:center;line-height:initial;background:#000;padding:", " ", " ", ";position:relative;@media ", "{padding:", " ", " ", ";}"], spacing('xl'), spacing('md'), spacing('l'), function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoint('medium');
}, spacing('xl'), spacing('l'), spacing('xl'));
var InnerWrapper = styled.div.withConfig({
  displayName: "Footerstyle__InnerWrapper",
  componentId: "sc-167xaf5-1"
})(["display:block;width:100%;height:100%;max-width:1400px;margin:0 auto;"]);
var FooterBranding = styled.div.withConfig({
  displayName: "Footerstyle__FooterBranding",
  componentId: "sc-167xaf5-2"
})(["display:block;width:100%;height:100%;margin:0 0 25px;"]);
var FooterCopyright = styled.div.withConfig({
  displayName: "Footerstyle__FooterCopyright",
  componentId: "sc-167xaf5-3"
})(["display:block;width:100%;height:100%;text-align:left;p{font-size:15px;line-height:24px;margin-bottom:5px;@media ", "{font-size:16px;line-height:27px;}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoint('medium');
});
var Brand = styled(Link).withConfig({
  displayName: "Footerstyle__Brand",
  componentId: "sc-167xaf5-4"
})(["color:transparent;margin-right:auto;border:0;:hover{border:0;}"]);
var SocialIconWrapper = styled.div.withConfig({
  displayName: "Footerstyle__SocialIconWrapper",
  componentId: "sc-167xaf5-5"
})([""]);
export { FooterWrapper, InnerWrapper, FooterCopyright, FooterBranding, SocialIconWrapper, Brand };